import { getChatMessageKey } from "web_myplann/Chat/Helpers/getChatMessageKey";
import type {
	ChatMessageDirection,
	ChatMessageView,
} from "web_myplann/Chat/Types/chatMessage";
import {
	dateFormatter,
	ISO_DATE_FORMAT,
} from "web_myplann/Shared/Utils/dateFormatters";

export type ChatMessageGroupView = {
	key: string;
	dayKey: string;
	date?: Date;
	direction: ChatMessageDirection;
	messages: ChatMessageView[];
};

export const groupChatMessages = (
	messages: ChatMessageView[],
): ChatMessageGroupView[] => {
	const sorted = [...messages].sort((a, b) => {
		const byCreatedAt = a.createdAt.getTime() - b.createdAt.getTime();
		if (byCreatedAt !== 0) return byCreatedAt;

		return (a.sequence ?? 0) - (b.sequence ?? 0);
	});
	const groups: ChatMessageGroupView[] = [];

	for (const message of sorted) {
		const dayKey = dateFormatter(message.createdAt, ISO_DATE_FORMAT);
		const lastGroup = groups.at(-1);
		const startsNewDay = lastGroup?.dayKey !== dayKey;

		if (!startsNewDay && lastGroup.direction === message.direction) {
			lastGroup.messages.push(message);
			continue;
		}

		groups.push({
			key: getChatMessageKey(message),
			dayKey,
			date: startsNewDay ? message.createdAt : undefined,
			direction: message.direction,
			messages: [message],
		});
	}

	return groups;
};
